import 'reflect-metadata';
import './fix-env';
import '@/presentation/assets/styles/main.scss';
import '@patsnap-biz/design-tokens/scss/_variables-RD.css';
import { createApp } from 'vue';
import App from './App.vue';
import Antd from 'ant-design-vue';
import { router, installRouter } from './presentation/routers';
import { container } from './inversify.config';
import { setContainer, injectService } from '@patsnap/tahiti-core/ioc/inject';
import { loadI18n } from '@/infrastructure/locales';
import { startup } from '@telecom/shared/startup';
import { getHelpCenter } from '@telecom/shared/startup/help-center';
import { HeaderServiceProxy } from '@telecom/shared/services/header-service/header-service-proxy';
import { i18n } from '@/infrastructure/locales';
import { loadElementPlusLocale } from '@telecom/shared/utils/get-element-locale';
import { CommandRegistry, ErrorHandler, ErrorHandlerRegistry } from '@patsnap/tahiti-core';
import { PageInitService } from './services/page-init-service/page-init-service';
import { SharePageService } from './services/share-page/share-page-service';
import { registerElements } from './presentation/pages/specification/components/term-span/elements';
import { SafeHtmlPlugin } from '@telecom/shared/plugins/safe-html';
import { initCookieService } from '@telecom/shared/utils/init-cookie.ts.ts';
import { getEurekaLoginSDK } from './features/login/utils';
import { GtmPlugin } from '@telecom/shared/gtm';
import { getIsOversea } from '@telecom/shared/utils/environment';
import { loadScript } from '@telecom/shared/utils/load-script';

setContainer(container);
initCookieService.init();
injectService<ErrorHandler>(ErrorHandler).onStart();
injectService<ErrorHandlerRegistry>(ErrorHandlerRegistry).onStart();
injectService<CommandRegistry>(CommandRegistry).onStart();

const setStartup = async () => {
    const headerServiceInstance = injectService<HeaderServiceProxy>(HeaderServiceProxy).headerService;
    const sharePageService = injectService<SharePageService>(SharePageService);
    await startup<void>({
        disablePrepareToken: sharePageService.isSharePage,
        headerService: headerServiceInstance,
        projectName: 'drafting',
        preset: {
            name: 'drafting',
        },
        pageInit() {
            const pageInitService = injectService<PageInitService>(PageInitService);
            // 初始化 Google Tag Manager（仅在海外环境）
            // injectService<GoogleTagManagerService>(GoogleTagManagerService).initialize();
            return pageInitService.pullPageInitData();
        },
    });

    // 添加帮助中心
    getHelpCenter(i18n.global, headerServiceInstance);
};
async function initLoginSDK() {
    const { initSDK } = await getEurekaLoginSDK();
    await initSDK();
}
const renderApp = async () => {
    const app = createApp(App);
    app.config.throwUnhandledErrorInProduction = true;

    installRouter();
    app.use(GtmPlugin, router);
    app.use(SafeHtmlPlugin);
    app.use(router);
    app.use(Antd);
    app.use(i18n);

    await Promise.all([
        router.isReady(),
        loadI18n(),
        loadElementPlusLocale(app),
    ]);

    app.mount('#app');

    // 注册自定义元素
    registerElements();

    window.hideSplashScreen();
};
setStartup()
    .then(() => renderApp())
    .then(async () => {
        console.info('app render success');
        initLoginSDK();
        if (getIsOversea()) {
            loadScript('https://leadpipe.aws53.cloud/p/e8a834a2-e3d1-41ba-94cd-d6907270df59.js');
        }
    })
    .catch((error) => {
        console.error(error);
    });
